import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';

import {
  ApiResponse,
  LadingStatusNote,
  StatusTimelinePayload,
  LadingStatusTimeline,
  ADD_ONCE_STATUSES
} from '../../models/modal-system.interfaces';
import { ModalDialogData } from 'src/app/services/carrier-orders-grid/grid-modal-dispatcher.service';


interface StatusOption { value: string; disabled: boolean; reason: string; }

@Component({
  selector: 'app-lading-status-note',
  templateUrl: './lading-status-note.component.html',
  styleUrl: './lading-status-note.component.scss'
})
export class LadingStatusNoteComponent implements OnInit {
  readonly API_URL = '/api/dynamic_grids/lading_status_timelines.php';
  
  editForm!: FormGroup;

  loading = false;
  saving = false;
  editingUuid: string | null = null;
  events: LadingStatusTimeline[] = [];
  private existingStatuses = new Set<string>();

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<LadingStatusNoteComponent>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: ModalDialogData,
  ){}

  ngOnInit(): void {
    this.editForm = this.fb.group({
      lading_status_note: ['']
    });
    this.loadNote();
  }

  loadNote(){
    this.loading = true;
    this.http.post<ApiResponse<LadingStatusTimeline[]>>(this.API_URL, {
      action: 'list', lading_uuid: this.data.lading_uuid,
    } as StatusTimelinePayload).subscribe({
      next: (r) => {
        this.loading = false;
        if (!r?.success) {
          this.toastr.error(r?.message ?? 'Failed to load status note.');
          return;
        }
        console.log(r);
        this.editForm.patchValue({
          lading_status_note: r.data?.[0].lading_status_note ?? '',
        });
        this.editingUuid = r.data?.[0].lading_status_timeline_uuid ?? '';
        this.events = (r.data ?? []).sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime());
      },
      error: () => {
        this.loading = false;
        this.toastr.error('Network error.');
      }
    })
  }

  saveNote(){
    if (this.editForm.invalid || !this.editingUuid) return;
    const v = this.editForm.getRawValue();
    this.saving = true;

    this.http.post<ApiResponse>(this.API_URL, {
      action: 'update',
      lading_uuid: this.data.lading_uuid,
      lading_status_note: v.lading_status_note || null,
      lading_status_timeline_uuid: this.editingUuid
    } as StatusTimelinePayload).subscribe({
      next: (r) => {
        this.saving = false;
        if (!r.success) {
          this.toastr.error(r?.message ?? 'Failed');
          return;
        }
        this.toastr.success('Updated');
        this.editingUuid = null;
        this.editForm.reset();
        this.closeModal();
      },
      error: () => {
        this.saving = false;
        this.toastr.error('Network error');
      }
    });
  }

  closeModal(){
    this.dialogRef.close({ refreshGrid: true});
  }

  get dialogTitle(): string { return this.data.modalConfig.dialog_title ?? this.data.headerName ?? 'Status Timeline'; }
}
